import { render, staticRenderFns } from "./commomPageButtonWidge.vue?vue&type=template&id=c205e246&scoped=true"
import script from "./commomPageButtonWidge.vue?vue&type=script&lang=js"
export * from "./commomPageButtonWidge.vue?vue&type=script&lang=js"
import style0 from "./commomPageButtonWidge.vue?vue&type=style&index=0&id=c205e246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c205e246",
  null
  
)

export default component.exports